// removed by extract-text-webpack-plugin
module.exports = {"MainDiv":"Contact__MainDiv__2dbMo","Image":"Contact__Image__307nk","Arrow":"Contact__Arrow__3H76W","Content":"Contact__Content__3eZAW","SendButton":"Contact__SendButton__3EyJ4","Error":"Contact__Error__3OK_N","Success":"Contact__Success__1xqCQ"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Home/Contact/Contact.css
// module id = 401
// module chunks = 0